<template>
  <page no-styling style="overflow: hidden;" class="pb4">
    <div class="card slightly_yellow_background">
      <card-header
        :title="$t('cms.dealcalculator.Title')"
        :description="$t('cms.dealcalculator.Description')"
        :infoConfig="$CONSTANTS.infoConfig.dealCalculator"
      >
        <template #icon>
          <icon iconName="calculator" xlarge />
        </template>
      </card-header>

      <deal-calculator-item
        v-model="numberOfGuests"
        :title="$t('cms.dealcalculator.NumberOfGuest.Title')"
        :description="$t('cms.dealcalculator.NumberOfGuest.Desctiption')"
        :min="0"
        :max="500"
        :step="10"
        :can-higher-max="true"
      />

      <div class="dot-divider" />

      <deal-calculator-item
        v-model="couponUse"
        :title="$t('cms.dealcalculator.CouponUse.Title')"
        :description="$t('cms.dealcalculator.CouponUse.Desctiption')"
        :min="0"
        :max="100"
        :step="1"
        :can-higher-max="false"
        suffix="%"
      />

      <div class="dot-divider" />

      <deal-calculator-item
        v-model="pricePerDeal"
        :title="$t('cms.dealcalculator.PricePerDeal.Title')"
        :description="$t('cms.dealcalculator.PricePerDeal.Desctiption')"
        :min="0"
        :max="100"
        :step="1"
        :can-higher-max="true"
        :prefix="currencySymbol"
      />

      <div class="dot-divider" />

      <deal-calculator-item
        v-model="daysPerYear"
        :title="$t('cms.dealcalculator.DaysPerYear.Title')"
        :description="$t('cms.dealcalculator.DaysPerYear.Desctiption')"
        :min="0"
        :max="365"
        :step="1"
        :can-higher-max="false"
      />

      <div class="dot-divider" />

      <deal-calculator-item
        v-model="margin"
        :title="$t('cms.dealcalculator.Margin.Title')"
        :description="$t('cms.dealcalculator.Margin.Desctiption')"
        :min="0"
        :max="100"
        :step="1"
        :can-higher-max="false"
        suffix="%"
      />
    </div>

    <div class="card-spacing" />

    <div class="card deal-calculator-summary">
      <h1 class="header">{{ $t('cms.dealcalculator.TotalSummary') }}</h1>
      <div class="report-row">
        <p>{{ $t('cms.dealcalculator.NumberOfGuest.Summary') }}</p>
        <p class="pr2">{{ numberOfGuests }}</p>
      </div>
      <div class="report-row">
        <p>{{ $t('cms.dealcalculator.CouponUse.Summary') }}</p>
        <p class="pr2">{{ couponUse }}%</p>
      </div>
      <div class="report-row">
        <p>{{ $t('cms.dealcalculator.PricePerDeal.Summary') }}</p>
        <p class="pr2">{{ formatCurrency(pricePerDeal) }}</p>
      </div>
      <div class="report-row">
        <p>{{ $t('cms.dealcalculator.DaysPerYear.Summary') }}</p>
        <p class="pr2">{{ daysPerYear }}</p>
      </div>
      <div class="report-row">
        <p>{{ $t('cms.dealcalculator.Margin.Summary') }}</p>
        <p class="pr2">{{ margin }}%</p>
      </div>

      <div class="dot-divider-light" />

      <div class="report-row">
        <p class="bold">{{ $t('cms.dealcalculator.TotalRevenue') }}</p>
        <p class="total-venue">{{ formatCurrency(this.totalRevenue) }}</p>
      </div>

      <div class="dot-divider-light" />

      <div class="report-row">
        <p class="bold">{{ $t('cms.dealcalculator.TotalMargin') }}</p>
        <p class="bold pr2">{{ totalMarginWithFormat }}</p>
      </div>
    </div>
  </page>
</template>

<script>
import CardHeader from '@/components/global/CardHeader.vue';
import store from '@/store';
import DealCalculatorItem from './DealCalculatorItem.vue';

export default {
  components: {
    CardHeader,
    DealCalculatorItem,
  },
  data() {
    return {
      numberOfGuests: 200,
      couponUse: 8,
      pricePerDeal: 36,
      daysPerYear: 365,
      margin: 30,
    };
  },

  methods: {
    // get comma as decimal separator and period for thousands or the other way around
    formatCurrency(number) {
      // filter for dash so we can't get e.g. 'en' instead of 'en-US'
      const locale = window.navigator.languages.filter(language => language.includes('-'))[0] || 'nl-NL';
      return `${this.currencySymbol}${new Intl.NumberFormat(locale).format(number)}`;
    },
  },

  computed: {
    currencySymbol() {
      return store.state.organization.currencySymbol;
    },

    totalRevenue() {
      return this.numberOfGuests * (this.couponUse / 100) * this.pricePerDeal * this.daysPerYear;
    },

    totalMarginWithFormat() {
      let result = this.totalRevenue * (this.margin / 100);
      result = Number.isNaN(result) ? 0 : result;
      return this.formatCurrency(result);
    },
  },
};
</script>

<style lang="scss" scoped>
.dot-divider {
  border-bottom: 2px dotted rgba(0, 0, 0, .2);
}

.dot-divider-light {
  margin: 16px 0;
  border-bottom: 2px dotted rgba(255, 255, 255, .5);
}

.deal-calculator-summary{
  padding: 16px;
  background-color: $color_purple;

  .header {
    font-size: 16px;
    font-weight: bold;
    color: white;
  }

  .report-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      color: white;
    }
    .total-venue {
      display: block;
      padding: 8px 12px;
      background-color: $color_background_light_blue;
      color: black;
      font-weight: bold;
      border-radius: 8px;
    }
  }
}
</style>
